import { RootState } from "@/app/stores"

export const selectAclList = (state: RootState) => state.acl.aclList
export const selectVisibilityAclTable = (state: RootState) => state.acl.visibilityAclTable
export const selectAclLoading = (state: RootState) => state.acl.isLoading
export const selectVisibilityAclTableLoading = (state: RootState) => state.acl.isVisibilityTableLoading
export const selectAclFirstLoad = (state: RootState) => state.acl.isFirstLoad
export const selectAclError = (state: RootState) => state.acl.error
